var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.109 -694.405)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-210.459,703.213l-1.457-1.456-3.688,3.688-3.692-3.692-1.465,1.465,3.692,3.692-3.686,3.686,1.457,1.456,3.686-3.686,3.69,3.69,1.465-1.465-3.69-3.69Z",
    transform: "translate(-0.5 -0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon-cancel.48937f9340f6475e21a8a5e63fc427df.svg";
export { ForwardRef as ReactComponent };